module.exports = __webpack_public_path__ + "img/truck-shipped_filled.4de03e8.png";